import Headhesive from "headhesive";
import * as bootstrap from 'bootstrap';

'use strict';
var header = {
    /**
     * Theme's components/functions list
     * Comment out or delete the unnecessary component.
     * Some components have dependencies (plugins).
     * Do not forget to remove dependency from src/js/vendor/ and recompile.
     */
    init: function () {
        header.stickyHeader();
        header.subMenu();
        header.offCanvas();
    },
    /**
     * Sticky Header
     * Enables sticky behavior on navbar on page scroll
     * Requires assets/js/vendor/headhesive.min.js
     */
    stickyHeader: () => {
        var navbar = document.querySelector(".navbar");
        if (navbar == null) return;
        var options = {
            offset: 350,
            offsetSide: 'top',
            classes: {
                clone: 'navbar-clone fixed',
                stick: 'navbar-stick',
                unstick: 'navbar-unstick',
            },
            onStick: function () {
                var navbarClonedClass = this.clonedElem.classList;
                if (navbarClonedClass.contains('transparent') && navbarClonedClass.contains('navbar-dark')) {
                    this.clonedElem.className = this.clonedElem.className.replace("navbar-dark", "navbar-light");
                }
            }
        };
        var banner = new Headhesive('.navbar', options);
    },
    /**
     * Sub Menus
     * Enables multilevel dropdown
     */
    subMenu: () => {
        (function ($bs) {
            const CLASS_NAME = 'has-child-dropdown-show';
            $bs.Dropdown.prototype.toggle = function (_original) {
                return function () {
                    document.querySelectorAll('.' + CLASS_NAME).forEach(function (e) {
                        e.classList.remove(CLASS_NAME);
                    });
                    let dd = this._element.closest('.dropdown').parentNode.closest('.dropdown');
                    for (; dd && dd !== document; dd = dd.parentNode.closest('.dropdown')) {
                        dd.classList.add(CLASS_NAME);
                    }
                    return _original.call(this);
                }
            }($bs.Dropdown.prototype.toggle);
            document.querySelectorAll('.dropdown').forEach(function (dd) {
                dd.addEventListener('hide.bs.dropdown', function (e) {
                    if (this.classList.contains(CLASS_NAME)) {
                        this.classList.remove(CLASS_NAME);
                        e.preventDefault();
                    }
                    e.stopPropagation();
                });
            });
        })(bootstrap);
    },
    /**
     * Offcanvas
     * Enables offcanvas-nav, closes offcanvas on anchor clicks, focuses on input in search offcanvas
     */
    offCanvas: () => {
        var navbar = document.querySelector(".navbar");
        if (navbar == null) return;
        const navOffCanvasBtn = document.querySelectorAll(".offcanvas-nav-btn");
        const navOffCanvas = document.querySelector('.navbar:not(.navbar-clone) .offcanvas-nav');
        const bsOffCanvas = new bootstrap.Offcanvas(navOffCanvas, {
            scroll: true
        });
        const scrollLink = document.querySelectorAll('.onepage .navbar li a.scroll');
        const searchOffcanvas = document.getElementById('offcanvas-search');
        navOffCanvasBtn.forEach(e => {
            e.addEventListener('click', event => {
                bsOffCanvas.show();
            })
        });
        scrollLink.forEach(e => {
            e.addEventListener('click', event => {
                bsOffCanvas.hide();
            })
        });
        if (searchOffcanvas != null) {
            searchOffcanvas.addEventListener('shown.bs.offcanvas', function () {
                document.getElementById("search-form").focus();
            });
        }
        window.addEventListener('resize', function (event) {
            if (window.matchMedia("(max-width: 991px)").matches) {
                //
            } else {
                bsOffCanvas.hide();
            }
        }, true);

    },
}
header.init();